var map = {
	"./adchoices.svg": 79,
	"./ajax-loader.gif": 80,
	"./arrow-icon-green.svg": 81,
	"./arrow-icon.svg": 82,
	"./badge-att.png": 83,
	"./badge-tmobile.png": 84,
	"./badge-verizon.png": 85,
	"./banner-desktop.jpg": 86,
	"./banner-mobile-1x.jpg": 87,
	"./banner-mobile-2x.jpg": 88,
	"./best-price.png": 89,
	"./comcast.svg": 90,
	"./external-link.svg": 91,
	"./faster-speed.png": 92,
	"./icon-5G-simple.svg": 93,
	"./icon-5g.svg": 94,
	"./icon-bars.svg": 95,
	"./icon-close.svg": 25,
	"./icon-dollar.svg": 96,
	"./icon-freedom.svg": 97,
	"./icon-people.svg": 98,
	"./icon-phone-tick.svg": 99,
	"./icon-play.svg": 100,
	"./icon-refresh.svg": 101,
	"./icon-tag.svg": 102,
	"./icon-tower.svg": 103,
	"./icon-trade.svg": 104,
	"./icon-wifi-tower.svg": 105,
	"./icon-wifi.svg": 106,
	"./icon-x.svg": 107,
	"./iphone-xmas-gift.png": 108,
	"./lifestyle-connected.jpg": 109,
	"./lifestyle-control.jpg": 110,
	"./lifestyle-lines.jpg": 111,
	"./lines.svg": 112,
	"./phone.svg": 113,
	"./support.svg": 114,
	"./switch.png": 115,
	"./trade.svg": 116,
	"./xfinity-black-friday-sale.png": 117,
	"./xfinity-black.svg": 26,
	"./xfinity.svg": 27,
	"./xm-black.svg": 118,
	"./xm-white.svg": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9;